export class RegisterBenefReq {
  account_type: number;
  has_index_no: boolean;
  first_name: string;
  middle_name: string;
  last_name: string;
  sex: string;
  password: string;
  benef_index_no: string;
  email: string;
  phone_number: string;
}
